import type { ReactElement } from 'react';
import { twMerge } from 'cn';

/**
 * Component that displays a 'setting' description of the selected section
 */
export const SectionDescription = ({
  className,
  section,
  description
}: {
  className?: string;
  section: string;
  description?: string;
}): ReactElement => {
  return (
    <>
      <div className={twMerge('flex flex-col gap-2', className)}>
        <h2 className='leading-none text-lg font-demibold text-foreground'>{section}</h2>
        <p className='mt-[-7px] text-sm font-medium text-foreground/75'>
          {description || `Configure your ${section} from your camera into the Studio.`}
        </p>
      </div>
    </>
  );
};
